<template>
  <vg-card
      class="vg-collapse-panel no-padding"
      :class="{'fixed-on': fixedOn}"
  >
    <van-collapse
        :value="activeNames"
        @input="onInput"
    >
      <van-collapse-item :title="title"
                         name="1">
        <slot/>
      </van-collapse-item>
    </van-collapse>
  </vg-card>
</template>

<script>
import {Collapse, CollapseItem} from 'vant';
import VgCard from "@/components/Commons/VgCard.vue";

export default {
  name: 'VgCollapsePanel',
  components: {
    VgCard,
    'van-collapse': Collapse,
    'van-collapse-item': CollapseItem
  },
  props: {
    title: String,
    fixedOn: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      activeNames: ['1']
    }
  },
  methods: {
    onInput(value) {
      if (this.fixedOn) {
        return
      }

      this.activeNames = value
    }
  }
}
</script>

<style scoped>

.vg-collapse-panel >>> .van-collapse-item__title .van-cell__right-icon::before {
  color: #C8C8C8;
  font-size: 20px;
}

.vg-collapse-panel >>> .van-collapse-item__title .van-cell__right-icon::before {
  transform: rotate(0deg);
}

.vg-collapse-panel >>> .van-collapse-item__title--expanded .van-cell__right-icon::before {
  transform: rotate(90deg);
}

.vg-collapse-panel >>> .van-collapse-item__title {
  padding: 10px;
  font-size: 16px;
  color: #000;
}

.vg-collapse-panel >>> .van-collapse-item__title--expanded::after {
  border: solid 1px #E7E5E7;
  left: 10px;
  right: 10px;
}

.vg-collapse-panel >>> .van-collapse-item__content {
  padding: 0px;
}

.vg-collapse-panel.fixed-on >>> .van-icon {
  display: none;
}
</style>